import { Field, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import { useGetAllPlacesList } from "../../Parameters/Geographicals/Places/api/getAllPlacesList";

const CreateUnitForm = ({ initialValues, onSubmit }: CreateUnitFormProps) => {
  const { t } = useTranslation();

  const getAllPlacesListQuery = useGetAllPlacesList();

  const validationSchema= Yup.object({
    description: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    unID:Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
  })

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
          onSubmit(values, formikHelpers);
      }}
      validationSchema={validationSchema}
    >
      {({ errors, touched, isSubmitting, values, getFieldProps }) => (
        <Form>
          <Container fluid className="p-0">
          <Row>
            <Col xs={6}>
                <label className="form-label">
                  {`${t("Περιγραφή")}*`}
                </label>
                <Field
                  name="description"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="description"
                 
                />
                <div className="text-danger">
                  {errors.description && touched.description && (
                    <div>{errors.description}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Τοποθεσία")}`}
                </label>
                <Field
                  as="select"
                  name="placeID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="placeID"
                >
                <option value="">{t("Επιλέξτε Τοποθεσία")}</option>
                {getAllPlacesListQuery.data &&
                  getAllPlacesListQuery.data.map((place) => (
                    <option key={place.id} value={place.id}>
                      {place.name}
                    </option>
                  ))}
              </Field>
                <div className="text-danger">
                  {errors.placeID && touched.placeID && (
                    <div>{errors.placeID}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Κωδικός μονάδας")}*`}
                </label>
                <Field
                  name="unID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="unID"
                 
                />
                <div className="text-danger">
                  {errors.unID && touched.unID && (
                    <div>{errors.unID}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Κωδικός SAP")}`}
                </label>
                <Field
                  name="sapCode"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="sapCode"
                 
                />
                <div className="text-danger">
                  {errors.sapCode && touched.sapCode && (
                    <div>{errors.sapCode}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Εμπορική")}`}
                </label>
                <Field
                  type="checkbox"
                  name="isEmporiki"
                  field="isEmporiki"
                />
                <div className="text-danger">
                  {errors.isEmporiki && touched.isEmporiki && (
                    <div>{errors.isEmporiki}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Citibank")}`}
                </label>
                <Field
                  type="checkbox"
                  name="isCiti"
                  field="isCiti"
                />
                <div className="text-danger">
                  {errors.isCiti && touched.isCiti && (
                    <div>{errors.isCiti}</div>
                  )}
                </div>
              </Col>
          
            </Row>
          </Container>

          <div className="mb-3">
            <Button
              type="submit"
              size="sm"
              styletype="primary"
              disabled={isSubmitting}
            >
              {t("Δημιουργία")}
            </Button>
          </div>
        </Form>
    )}
    </Formik>
)
}
export default CreateUnitForm;

type CreateUnitFormProps =
  {
      initialValues: ICreateUnitForm;
      onSubmit: (
        values: ICreateUnitForm,
        formikHelpers: FormikHelpers<ICreateUnitForm>
      ) => void;
    }
  

